module.exports = __webpack_public_path__ + "static/img/service2.cc778a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service2.png
// module id = lK4H
// module chunks = 0